// extracted by mini-css-extract-plugin
module.exports = {"trackingPlaceholder":"FlexibilityFilter-module__trackingPlaceholder___ykcWP","addNewFilters":"FlexibilityFilter-module__addNewFilters___gaNkR"};